export default __webpack_public_path__ + "static/media/07.d4e45734.jpg";